import { Tooltip as AntTooltip, TooltipProps as AntdTooltipProps } from 'antd';

export function Tooltip({ placement = 'top', ...props }: AntdTooltipProps) {
  return (
    <AntTooltip
      {...props}
      placement={placement}
      destroyOnHidden
      mouseEnterDelay={0.5}
      mouseLeaveDelay={0}
    >
      {props.children}
    </AntTooltip>
  );
}
